import axios, { isAxiosError } from 'axios';
import posthog from 'posthog-js';
class TimeSheetService {
    static auth;
    static config;
    constructor(auth, config) {
        TimeSheetService.auth = auth;
        TimeSheetService.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${TimeSheetService.auth.currentToken}`,
        };
    }
    async fetchTimeSheetReport(query) {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/time-sheet`, {
                params: query,
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async queryShifts(query) {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/shift`, {
                params: query,
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async fetchShift(id) {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/shift/${id}`, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async rejectShift(id) {
        try {
            const { data } = await axios.delete(`${TimeSheetService.config.API.baseApiUrl}/employee/shift/${id}`, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async fetchTracking(shiftId) {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/shift/${shiftId}/tracking`, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async fetchLiveTracking() {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/tracking`, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async createShift(shift) {
        try {
            const { data } = await axios.post(`${TimeSheetService.config.API.baseApiUrl}/employee/shift`, shift, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async updateShift(id, shift) {
        try {
            const { data } = await axios.put(`${TimeSheetService.config.API.baseApiUrl}/employee/shift/${id}`, shift, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async updateCompanyConfig(companyConfig) {
        try {
            const { data } = await axios.post(`${TimeSheetService.config.API.baseApiUrl}/employee/company-configuration`, companyConfig, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            posthog.captureException(error);
            throw error;
        }
    }
    async getCompanyConfig() {
        try {
            const { data } = await axios.get(`${TimeSheetService.config.API.baseApiUrl}/employee/company-configuration`, {
                headers: this.headers(),
            });
            return data;
        }
        catch (error) {
            // suppress 404 errors
            if (isAxiosError(error) && error.response?.status === 404) {
                return null;
            }
            posthog.captureException(error);
            throw error;
        }
    }
}
export default TimeSheetService;
//# sourceMappingURL=TimeSheet.service.js.map